/**
* Copyright (c) 2019 Vendor Badge, LLC All Rights Reserved.
* Created Date: Monday, 8th April 2019
* 
*  Functional Component for Email Address
*/
import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

// Material UI
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControl from '@material-ui/core/FormControl';
import Email from '@material-ui/icons/Email';

const EmailInput = (props) => {
  const { classes, id, onChange, hasIcon, InputProps, InputLabelProps, labelText, ...rest } = props;

  return (
    <FormControl>
      <InputLabel htmlFor='email' {...InputLabelProps}>{labelText}</InputLabel>
      <Input
        id={id}
        type='email'
        name='email'
        fullWidth
        onChange={onChange}
        endAdornment={ 
          hasIcon && (
          <InputAdornment position='end'>
            <Email className={classes.iconButton} />
          </InputAdornment>
          )
        }
        {...InputProps}
        {...rest}
      />
    </FormControl>
  )
}

EmailInput.propTypes = {
  classes: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  hasIcon: PropTypes.bool,
  labelText: PropTypes.string,
  InputProps: PropTypes.object,
  InputLabelProps: PropTypes.object
}

EmailInput.defaultProps = {
  InputProps: {
    margin: 'dense',
  },
  hasIcon: true,
  labelText: 'Email Address',
}

const styles = theme => ({
  iconButton: {
    color: theme.palette.type === 'light' ? 'rgb(128, 128, 128)' : theme.palette.common.white,
    padding: '0',
  },
});

export default withStyles(styles, { withTheme: true })(observer(EmailInput));